"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandeddeliverysm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandeddeliverysm` : '') + (description ? ` desc-brandeddeliverysm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandeddeliverysm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandeddeliverysm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87 1.85 3 14l7 3.5 7-3.5-1.87-12.15a1 1 0 0 0-.99-.85H5.86a1 1 0 0 0-.99.85ZM7.5 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 10a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m15.8 11.29-5.93-1.2a1.13 1.13 0 0 0-1.46 1.5 1.12 1.12 0 0 0 .62.6l3.22 1.67-3.28 1.28s-.88.05-7.24-4a1.13 1.13 0 0 0-1.7 1.2c.06.28.23.54.48.7.32.2 7.16 5.96 9.1 5.96 1.94 0 8.39-2.57 8.39-2.57V10l-2.2 1.29Z",
    fill: "#F4BD96"
  }));
};
var _default = exports.default = brandeddeliverysm;